import { createSlice } from "@reduxjs/toolkit";

export const customerDataSlice = createSlice({
  name: "customerData",
  initialState: null,
  reducers: {
    setCustomerData: (state, action) => {
      return action.payload;
    },
  },
});

export const { setCustomerData } = customerDataSlice.actions;
export default customerDataSlice.reducer;
